"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * Serialization/deserialization of {@link SelloutTerminationReportRowDTO}.
 *
 * @author Jan Prokop
 */


var SelloutTerminationReportRowDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutTerminationReportRowDTOConverter, _DataObjectConverter_);

  function SelloutTerminationReportRowDTOConverter() {
    _classCallCheck(this, SelloutTerminationReportRowDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutTerminationReportRowDTOConverter).apply(this, arguments));
  }

  return SelloutTerminationReportRowDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutTerminationReportRowDTOConverter = SelloutTerminationReportRowDTOConverter;